<script>
  import { apiServer } from "../config.js";
  import { redirect } from "../pager";
  import Alert from "../components/Alert.svelte";
  import { fade } from "svelte/transition";
  import Load from "../components/Load.svelte";
  import SkContent from "./Rule/SkContent.svelte";
  import KpContent from "./Rule/KpContent.svelte";
  import Modal from "../components/Modal.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import Title from "../components/Title.svelte";

  import AXHR from "../components/js/axhr.js";

  import { session } from "../components/js/store.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });
  let alert = [];
  let shake = "shake";
  let require;

  $: require = {
    username: "",
    password: "",
    name: "",
    dns: "",
    iface: "",
    ipAddress: "",
    isPublic: "",
    descriptions: "",
    setuju: "",
  };
  let number;
  $: number = {};

  let require_check;

  $: require_check = {
    username: "",
    password: "",
    name: "",
    dns: "",
    iface: "",
    ipAddress: "",
    isPublic: "",
    descriptions: "",
    setuju: "",
  };
  let number_check;
  $: number = {};

  let username;
  $: username = {};

  //#FORM Data Payload

  let errorForm = [];
  function validator() {
    errorForm = [];
    for (var k in require) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        require[k] !== undefined &&
        require[k] !== null &&
        require[k] !== "" &&
        require[k] !== false
      ) {
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    for (var n in number) {
      if (document.getElementById(n + "-warning")) {
        document.getElementById(n + "-warning").style.display = "none";
        document.getElementById(n + "-labelwarning").style = "";
        document.getElementById(n + "-warning").innerHTML = "";
      }
      if (/^\+?(0|[1-9]\d*)$/.test(number[n])) {
      } else {
        errorForm = [
          ...errorForm,
          { field: n, message: "Pastikan Hanya Angka" },
        ];
        if (document.getElementById(n + "-warning")) {
          document.getElementById(n + "-warning").style.display =
            "inline-block";
          document.getElementById(n + "-warning").innerHTML =
            "Pastikan Hanya Angka";
        }
        if (document.getElementById(n + "-labelwarning")) {
          document.getElementById(n + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    for (var e in username) {
      if (document.getElementById(e + "-warning")) {
        document.getElementById(e + "-warning").style.display = "none";
        document.getElementById(e + "-labelwarning").style = "";
        document.getElementById(e + "-warning").innerHTML = "";
      }
      if (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          username[e]
        )
      ) {
      } else {
        errorForm = [
          ...errorForm,
          { field: e, message: "Pastikan username sudah tepat" },
        ];
        if (document.getElementById(e + "-warning")) {
          document.getElementById(e + "-warning").style.display =
            "inline-block";
          document.getElementById(e + "-warning").innerHTML =
            "Pastikan username sudah tepat";
        }
        if (document.getElementById(e + "-labelwarning")) {
          document.getElementById(e + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  let loading = false;
  let success;
  $: success = false;
  let files;
  $: if (files) {
    files = files[0];
  } else {
    files = "";
  }
  async function handleSubmit(event) {
    loading = true;
    let valid;
    let payload;
    valid = validator();

    let method = "post";
    let apiEndPoint;
    if (require.id) {
      method = "put";
      apiEndPoint = apiServer + "/rb/" + require.id;
      payload = {
        name: require.name,
        dns: require.dns,
        ipAddress: require.ipAddress,
        username: require.username,
        iface: require.iface,
        password: require.password,
        isPublic: require.isPublic,
        descriptions: require.descriptions,
        pic: files,
      };
    } else {
      method = "post";
      apiEndPoint = apiServer + "/rb";
      payload = {
        name: require.name,
        dns: require.dns,
        ipAddress: require.ipAddress,
        username: require.username,
        iface: require.iface,
        password: require.password,
        isPublic: require.isPublic,
        descriptions: require.descriptions,
        pic: files,
      };
    }
    if (valid) {
      shake = "";
      var data = payload;
      const aFormData = new FormData();
      aFormData.append("pic", files);
      aFormData.append("name", data.name);
      aFormData.append("dns", data.dns);
      aFormData.append("ipAddress", data.ipAddress);
      aFormData.append("username", data.username);
      aFormData.append("iface", data.iface);
      aFormData.append("password", data.password);
      aFormData.append("isPublic", data.isPublic);
      aFormData.append("descriptions", data.descriptions);
      var config = {
        method: method,
        url: apiEndPoint,
        headers: {
          Authorization: "Bearer " + sessions.token,
          "Content-Type": "multipart/form-data",
        },
        data: aFormData,
      };
      AXHR(config)
        .then(function (response) {
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: response.data.message,
              color: "green",
            },
          ];
          success = true;
          loading = false;
        })
        .catch(function (error) {
          success = false;
          loading = false;

          if (error.response.status == 401) {
            localStorage.removeItem("t");
            redirect("/splash");
            loadingLine = false;
          } else {
            shake = "shake";
            alert = [
              ...alert,
              {
                title: "Oops...",
                message: error.response.data.message,
                color: "yellow",
              },
            ];
          }
        });
    } else {
      success = false;
      loading = false;
      shake = "shake";
    }
  }

  let items = [];
  //navigation
  let navigation = [];
  $: if (sessions.loggedin == true) {
    if (sessions.user.firstName != undefined) {
      navigation["message"] =
        sessions.user.firstName + " " + sessions.user.lastName;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //SERVER LOAD
  $: dataFiltered = [];
  function checkSessionData(token, server) {
    if (token) {
      var config = {
        method: "get",
        url: sessions.api + "/rb",
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      AXHR(config).then(function (response) {
        let routeractive;
        let serverSelected;
        if (server) {
          serverSelected = server;
        } else {
          serverSelected = localStorage.getItem("_server_location");
        }
        if (sessions.routeractive) {
          if (serverSelected) {
            if (response.data[serverSelected]) {
              routeractive = response.data[serverSelected];
            } else {
              routeractive = response.data[0];
              localStorage.setItem("_server_location", 0);
            }
          } else {
            if (sessions.routeractive.name === response.data[0].name) {
              routeractive = sessions.routeractive;
            } else {
              routeractive = response.data[0];
            }
          }
        } else {
          if (serverSelected) {
            if (response.data[serverSelected]) {
              routeractive = response.data[serverSelected];
            } else {
              routeractive = response.data[0];
              localStorage.setItem("_server_location", 0);
            }
          } else {
            console.log(response.data);
            routeractive = response.data[0];
          }
        }
        let sessionData = {
          api: sessions.api,
          token: token,
          loggedin: true,
          user: sessions.user,
          routers: response.data,
          routeractive: routeractive,
          notifications: { invoice: 0, info: 0 },
        };
        session.update((n) => sessionData);

        dataFiltered = response.data;
      });
    }
  }
  function areaUpdate(selected) {
    if (localStorage.getItem("_server_location")) {
      localStorage.setItem("_server_location", selected);
    } else {
      localStorage.setItem("_server_location", selected);
    }
    checkSessionData(sessions.token, selected);
  }

  checkSessionData(sessions.token, false);

  function fillEdit(v) {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    document.getElementById("formAddServer").classList.add("shake");
    require = {
      id: v.id,
      username: v.username,
      password: "",
      name: v.name,
      dns: v.dns,
      iface: v.iface,
      ipAddress: v.ipAddress,
      isPublic: v.isPublic,
      descriptions: v.descriptions,
      setuju: "",
    };
    setTimeout(() => {
      document.getElementById("formAddServer").classList.remove("shake");
    }, 2500);
  }
  $: pingColor = "gray";
  async function checkServer(endpoint, token) {
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    AXHR(config)
      .then(function (response) {
        pingColor = "green";
      })
      .catch(function (error) {
        pingColor = "red";
      });
  }

  async function reActivate(id, token) {
    var config = {
      method: "post",
      url: apiServer + "/rb/" + id + "/reactivate",
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    AXHR(config)
      .then(function (response) {
        alert = [
          ...alert,
          {
            title: "Mikhub",
            message: response.data.message,
            color: "green",
          },
        ];

        document.getElementsByClassName("backdrop")[0].click();
        checkSessionData(sessions.token, false);
      })
      .catch(function (error) {
        alert = [
          ...alert,
          {
            title: "Oops...",
            message: error.response.data.message,
            color: "yellow",
          },
        ];
      });
  }
</script>

<svelte:head>
  <title>Mikhub - Your Server</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}

<Navigationbar backbtn="false" message={navigation["message"]} align="center" />
<main
  transition:fade
  class="max-w-screen-xl px-2 pt-0 mx-auto mb-2 lg:pt-16 md:pt-16"
>
  {#if loading}
    <Load />
  {/if}
  <div class={shake}>
    <div class="w-full mx-auto mt-32 md:mt-16 lg:mt-16">
      {#if success == true}
        <div
          class="flex flex-wrap items-center w-full mx-auto my-5 lg:my-0 md:w-2/4 lg:w-2/5"
        >
          <div class="w-full mx-auto mb-2">
            <div class="block p-5 py-10 bg-white rounded-lg shadow-md group">
              <p class="text-center">
                <b class="block mb-5 text-xl">Server data saved successfully!</b
                >If the configuration is correct, activate it and you can
                immediately use it
                <a
                  href="/"
                  class="block px-5 py-2 my-5 text-white bg-gray-600 rounded"
                  >DASHBOARD</a
                ><br />or<br />
                <a
                  on:click={(e) => checkSessionData(sessions.token, false)}
                  on:click={(success = false)}
                  href="/server"
                  class="block px-5 py-2 my-5 text-white bg-gray-600 rounded"
                  >Return to the server list</a
                >
              </p>
            </div>
          </div>
        </div>
      {:else}
        <div
          class="items-start block w-full gap-3 mx-auto my-5 lg:flex md:flex lg:my-0 "
        >
          <div
            class="flex flex-wrap items-center w-full mx-auto my-5 lg:w-2/5 md:w-1/2 lg:my-0 "
          >
            <div class="w-full mx-auto mb-2">
              <div class="block px-4 py-3 bg-white rounded-lg shadow-md group">
                <div class="pb-2">
                  <button
                    on:click={(e) => checkSessionData(sessions.token, false)}
                    type="button"
                    class="w-full px-5 py-2 text-gray-100 bg-gray-700 rounded-lg lg:w-1/3 md:w-2/3 text-1xl active:bg-gray-500 focus:outline-none"
                    ><svg
                      class="inline w-4 h-4"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                      />
                    </svg> Refresh</button
                  >
                </div>
                <div class="h-screen pb-10 overflow-y-auto">
                  {#if dataFiltered}
                    {#each dataFiltered as d, i}
                      {#if d.disabled == "Y"}
                        <div class="w-full">
                          <div
                            class="flex items-center justify-between gap-2 px-4 py-3 m-2 text-left bg-yellow-100 rounded-md shadow cursor-not-allowed hover:bg-yellow-200 hover:shadow-outline"
                          >
                            <div
                              class="flex items-center w-12 h-12 p-2 text-sm text-gray-800 bg-white rounded-full lg:h-20 md:h-16 lg:w-20 md:w-16 opacity-70"
                            >
                              <img
                                alt={d.name}
                                class="w-full"
                                src="{sessions.api}/logo/{d.logo}"
                              />
                            </div>
                            <div
                              class="w-4/5 text-base text-gray-800 lg:w-7/12 md:w-7/12"
                            >
                              <b>{d.name}</b><br />
                              {d.ipAddress}
                              {#if d.updated}
                                <br />
                                <span class="text-xs text-gray-600"
                                  >^up {d.updated}</span
                                >
                              {/if}
                            </div>
                            <div
                              class="flex items-center justify-end w-1/5 gap-2 lg:w-2/12 md:w-4-12"
                            >
                              {#if localStorage.getItem("_server_location")}
                                {#if sessions.routeractive.id === d.id}
                                  <span class="relative flex w-6 h-6"
                                    ><span
                                      class="absolute inline-flex w-6 h-6 bg-{pingColor}-300 rounded-full opacity-75 animate-ping"
                                    />
                                    <span
                                      class="relative inline-flex w-6 h-6 overflow-hidden rounded-full"
                                      ><img
                                        src="./assets/svg/gps.svg"
                                        width="27px"
                                        alt="gps"
                                      /></span
                                    ></span
                                  >
                                {/if}
                              {/if}
                              <Modal backdropClose size="lg:w-2/5 w-full">
                                <div slot="trigger" let:open>
                                  <span
                                    title="This Server Configuration Is Disabled, Please Pay to Activate"
                                    on:click={open}
                                    class="block px-2 py-1 text-xs text-center text-white bg-blue-500 rounded-md cursor-pointer"
                                    >Pay Now</span
                                  >
                                </div>
                                <div slot="header" class="text-center">
                                  <h1 class="text-lg">
                                    Please confirm your order
                                  </h1>
                                </div>
                                <div
                                  slot="content"
                                  class="h-auto"
                                  style="max-height:100%"
                                >
                                  <div class="w-full">
                                    <div
                                      class="flex items-center justify-between gap-2 px-4 py-3 my-2 text-left bg-gray-100 rounded-md shadow"
                                    >
                                      <div
                                        class="flex items-center w-12 h-12 p-2 text-sm text-gray-800 bg-white rounded-full lg:h-20 md:h-16 lg:w-20 md:w-16"
                                      >
                                        <img
                                          alt={d.name}
                                          class="w-full"
                                          src="{sessions.api}/logo/{d.logo}"
                                        />
                                      </div>
                                      <div
                                        class="w-4/5 text-base text-gray-800 lg:w-7/12 md:w-7/12"
                                      >
                                        <b>{d.name}</b><br />
                                        {d.ipAddress}
                                        {#if d.updated}
                                          <br />
                                          <span class="text-xs text-gray-600"
                                            >^up {d.updated}</span
                                          >
                                        {/if}
                                        {#if d.descriptions}
                                          <br />
                                          <span class="text-xs text-gray-600"
                                            >{d.descriptions}</span
                                          >
                                        {/if}
                                        {#if d.isPublic == "Y"}
                                          <br />
                                          <span class="text-xs text-gray-600"
                                            >^isPublic</span
                                          >
                                        {:else}
                                          <br />
                                          <span class="text-xs text-gray-600"
                                            >^private</span
                                          >
                                        {/if}
                                        <br />
                                        <span class="text-xs text-gray-600"
                                          >^ex {d.expired_at}</span
                                        >
                                      </div>
                                      <div
                                        class="flex items-center justify-end w-1/5 gap-2 lg:w-2/12 md:w-4-12"
                                      />
                                    </div>
                                    <div
                                      class="px-5 py-3 mt-5 text-sm text-center text-gray-600 border border-gray-600 rounded-md"
                                    >
                                      Make sure you have at least <b>200.000</b>
                                      points, you will activate the above server
                                      for the next 1 month by exchanging the points
                                      you have
                                    </div>
                                  </div>
                                  <button
                                    on:click|preventDefault
                                    on:click={(e) =>
                                      reActivate(d.id, sessions.token)}
                                    type="button"
                                    class="w-full px-6 py-2 mt-5 text-gray-100 bg-gray-700 rounded-lg text-1xl active:bg-gray-500 focus:outline-none"
                                    >PROCESS NOW</button
                                  >
                                </div>
                              </Modal>
                            </div>
                          </div>
                        </div>
                      {:else}
                        <div class="w-full">
                          <div
                            class="flex items-center justify-between gap-2 px-4 py-3 m-2 text-left bg-gray-100 rounded-md shadow cursor-pointer hover:bg-white hover:shadow-outline"
                          >
                            <div
                              class="flex items-center w-12 h-12 p-2 text-sm text-gray-800 bg-white rounded-full lg:h-20 md:h-16 lg:w-20 md:w-16"
                            >
                              <img
                                alt={d.name}
                                class="w-full"
                                src="{sessions.api}/logo/{d.logo}"
                              />
                            </div>
                            <div
                              title="Click To Connect"
                              on:click={() => areaUpdate(i)}
                              on:click={() =>
                                checkServer(
                                  sessions.api +
                                    "/rb/" +
                                    sessions.routeractive.id +
                                    "/ping",
                                  sessions.token
                                )}
                              class="w-4/5 text-base text-gray-800 lg:w-7/12 md:w-7/12"
                            >
                              <b>{d.name}</b><br />
                              {d.ipAddress}
                              {#if d.updated}
                                <br />
                                <span class="text-xs text-gray-600"
                                  >^up {d.updated}</span
                                >
                              {/if}
                              {#if d.descriptions}
                                <br />
                                <span class="text-xs text-gray-600"
                                  >{d.descriptions}</span
                                >
                              {/if}
                              {#if d.isPublic == "Y"}
                                <br />
                                <span class="text-xs text-gray-600"
                                  >^isPublic</span
                                >
                              {:else}
                                <br />
                                <span class="text-xs text-gray-600"
                                  >^private</span
                                >
                              {/if}
                              <br />
                              <span class="text-xs text-gray-600"
                                >^ex {d.expired_at}</span
                              >
                            </div>
                            <div
                              class="flex items-center justify-end w-1/5 gap-2 lg:w-2/12 md:w-4-12"
                            >
                              {#if localStorage.getItem("_server_location")}
                                {#if sessions.routeractive.id === d.id}
                                  <span class="relative flex w-6 h-6"
                                    ><span
                                      class="absolute inline-flex w-6 h-6 bg-{pingColor}-300 rounded-full opacity-75 animate-ping"
                                    />
                                    <span
                                      class="relative inline-flex w-6 h-6 overflow-hidden rounded-full"
                                      ><img
                                        src="./assets/svg/gps.svg"
                                        width="27px"
                                        alt="gps"
                                      /></span
                                    ></span
                                  >
                                {/if}
                              {/if}
                              <span
                                on:click|preventDefault={fillEdit(d)}
                                class="px-1 py-1 text-gray-100 bg-gray-200 rounded-full"
                                ><svg
                                  aria-hidden="true"
                                  class="inline-block w-6 h-6"
                                  width="6"
                                  height="6"
                                  viewBox="0 0 16 16"
                                  ><path
                                    d="M11.1 1.71l1.13 1.12c.2.2.2.51 0 .71L11.1 4.7 9.21 2.86l1.17-1.15c.2-.2.51-.2.71 0zM2 10.12l6.37-6.43 1.88 1.88L3.88 12H2v-1.88z"
                                  /></svg
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      {/if}
                    {:else}
                      <p
                        class="w-full p-5 mt-10 text-center bg-yellow-100 border-2 border-yellow-200 rounded-lg"
                      >
                        <b class="text-2xl">Oops... No server yet</b><br />You
                        don't have a server to use, please add your server first
                        to get started
                      </p>
                    {/each}
                  {:else}
                    <div class="w-full lg:w-auto">
                      <div
                        class="w-full p-2 mx-auto mb-2 text-xs bg-yellow-300 border-4 border-t border-b border-r border-yellow-600 border-solid rounded shadow-lg lg:w-auto color-white"
                      >
                        <h2 class="text-sm font-bold">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            class="inline-block w-5 h-5"
                          >
                            <path
                              d="M4 8a6 6 0 0 1 4.03-5.67 2 2 0 1 1 3.95 0A6 6 0 0
                                    1 16 8v6l3 2v1H1v-1l3-2V8zm8 10a2 2 0 1 1-4 0h4z"
                            />
                          </svg>
                          Oops..
                        </h2>
                        <p>
                          You don't have a linked server yet, please add your
                          server first
                        </p>
                      </div>
                    </div>
                  {/if}
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex flex-wrap items-center w-full mx-auto my-5 lg:w-3/5 md:w-1/2 lg:my-0 "
          >
            <div class="w-full mx-auto mb-2">
              <div
                class="block px-4 py-3 bg-white rounded-lg shadow-md group"
                id="formAddServer"
              >
                <Title
                  title="Manage Server"
                  subtitle="Configure your Server, adding a new server will use 200.000 points if available"
                  tipe="2"
                  href="./server"
                />
                <div id="stepcontID1" class="stepcontID">
                  <form
                    class="px-2"
                    autocomplete="off"
                    on:submit|preventDefault={handleSubmit}
                  >
                    <div class="block gap-10 lg:flex md:block flex-nowrap">
                      <div class="w-full lg:w-1/2 md:w-full">
                        <section class="mt-5">
                          <label
                            for="pic"
                            class="relative block text-sm font-light"
                          >
                            <input
                              class="w-full px-3 py-2 text-gray-700 border border-gray-500 rounded-lg"
                              name="pic"
                              id="pic"
                              type="file"
                              bind:files
                            />
                            <span
                              class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                              id="pic-labelwarning"
                              >Logo
                            </span>
                            <span
                              class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                              id="pic-warning"
                            />
                          </label>
                        </section>

                        <section class="mt-5">
                          <label
                            for="name"
                            class="relative block text-sm font-light"
                          >
                            <input
                              class="w-full rounded-lg form-input"
                              name="name"
                              id="name"
                              autocomplete="off"
                              type="text"
                              placeholder="Server Name"
                              bind:value={require.name}
                            />
                            <span
                              class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                              id="name-labelwarning"
                              >Server Name
                            </span>
                            <span
                              class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                              id="name-warning"
                            />
                          </label>
                        </section>
                        <section class="mt-5">
                          <label
                            for="dns"
                            class="relative block text-sm font-light"
                          >
                            <input
                              class="w-full rounded-lg form-input"
                              name="dns"
                              id="dns"
                              autocomplete="off"
                              type="text"
                              placeholder="DNS"
                              bind:value={require.dns}
                            />
                            <span
                              class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                              id="dns-labelwarning"
                              >DNS
                            </span>
                            <span
                              class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                              id="dns-warning"
                            />
                          </label>
                        </section>
                        <section class="mt-5">
                          <label
                            for="iface"
                            class="relative block text-sm font-light"
                          >
                            <input
                              class="w-full rounded-lg form-input"
                              name="iface"
                              id="iface"
                              autocomplete="off"
                              type="text"
                              placeholder="iface"
                              bind:value={require.iface}
                            />
                            <span
                              class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                              id="iface-labelwarning"
                              >iface (Name Of iface)
                            </span>
                            <span
                              class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                              id="iface-warning"
                            />
                          </label>
                        </section>
                      </div>
                      <div class="w-full lg:w-1/2 md:w-full">
                        <section class="mt-5">
                          <label
                            for="ipAddress"
                            class="relative block text-sm font-light"
                          >
                            <input
                              class="w-full rounded-lg form-input"
                              name="ipAddress"
                              id="ipAddress"
                              autocomplete="off"
                              type="text"
                              placeholder="IP Address"
                              bind:value={require.ipAddress}
                            />
                            <span
                              class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                              id="ipAddress-labelwarning"
                              >IP Address
                            </span>
                            <span
                              class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                              id="ipAddress-warning"
                            />
                          </label>
                        </section>
                        <section class="mt-5">
                          <label
                            for="username"
                            class="relative block text-sm font-light"
                          >
                            <input
                              class="w-full rounded-lg form-input"
                              name="username"
                              id="username"
                              autocomplete="off"
                              type="text"
                              placeholder="Username"
                              bind:value={require.username}
                            />
                            <span
                              class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                              id="username-labelwarning"
                              >Username
                            </span>
                            <span
                              class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                              id="username-warning"
                            />
                          </label>
                        </section>

                        <section class="mt-5">
                          <label
                            for="password"
                            class="relative block text-sm font-light"
                          >
                            <input
                              class="w-full rounded-lg form-input"
                              name="password"
                              id="password"
                              autocomplete="off"
                              type="password"
                              placeholder="Password"
                              bind:value={require.password}
                            />
                            <span
                              class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                              id="password-labelwarning"
                              >Password
                            </span>
                            <span
                              class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                              id="password-warning"
                            />
                          </label>
                        </section>
                        <section class="mt-5">
                          <label
                            for="descriptions"
                            class="relative block text-sm font-light"
                          >
                            <input
                              class="w-full rounded-lg form-input"
                              name="descriptions"
                              id="descriptions"
                              autocomplete="off"
                              type="text"
                              placeholder="Descriptions"
                              bind:value={require.descriptions}
                            />
                            <span
                              class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                              id="descriptions-labelwarning"
                              >Descriptions
                            </span>
                            <span
                              class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                              id="descriptions-warning"
                            />
                          </label>
                        </section>

                        <section class="mt-5">
                          <label
                            for="isPublic"
                            class="relative block text-sm font-light"
                          >
                            <select
                              class="w-full rounded-lg form-input"
                              name="isPublic"
                              id="isPublic"
                              autocomplete="off"
                              type="text"
                              placeholder="Hotspot isPublic"
                              bind:value={require.isPublic}
                            >
                              {#if require.isPublic == "Y"}
                                <option value="Y" selected>Yes</option>
                                <option value="N">No</option>
                              {:else}
                                <option value="Y">Yes</option>
                                <option value="N" selected>No</option>
                              {/if}
                            </select>
                            <span
                              class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                              id="isPublic-labelwarning"
                              >isPublic
                            </span>
                            <span
                              class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                              id="isPublic-warning"
                            />
                          </label>
                        </section>
                        <section class="mt-5">
                          <p class="flex text-xs text-gray-500">
                            <label
                              for="setuju"
                              class="relative flex text-sm font-light"
                            >
                              <input
                                name="setuju"
                                id="setuju"
                                type="checkbox"
                                class="my-1 mr-5 text-3xl rounded-lg form-checkbox hover:shadow-outline"
                                bind:checked={require.setuju}
                              />
                              <div>
                                I have read and read
                                <Modal backdropClose size="lg:w-2/5 w-full">
                                  <span slot="trigger" let:open>
                                    <span on:click={open} class="text-gray-500"
                                      >Terms and conditions
                                    </span>
                                  </span>
                                  <div slot="header" class="text-center">
                                    <h1 class="text-lg">
                                      Terms and conditions
                                    </h1>
                                  </div>
                                  <div
                                    slot="content"
                                    class="h-auto"
                                    style="max-height:100%"
                                  >
                                    <SkContent />
                                  </div>
                                </Modal>

                                and
                                <Modal backdropClose size="lg:w-2/5 w-full">
                                  <span slot="trigger" let:open>
                                    <span on:click={open} class="text-gray-500"
                                      >Privacy Policy
                                    </span>
                                  </span>
                                  <div slot="header" class="text-center">
                                    <h1 class="text-lg">Privacy Policy</h1>
                                  </div>
                                  <div
                                    slot="content"
                                    class="h-auto"
                                    style="max-height:100%"
                                  >
                                    <KpContent />
                                  </div>
                                </Modal>
                                Mikhub
                              </div>
                              <span
                                class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                                id="setuju-warning"
                              />
                            </label>
                          </p>
                        </section>
                      </div>
                    </div>
                    <div class="flex items-center justify-between gap-2 my-5">
                      {#if loading}
                        <button
                          type="submit"
                          class="w-auto px-16 py-2 mt-5 text-gray-100 bg-gray-500 rounded-lg opacity-25 text-1xl active:bg-gray-500 focus:outline-none"
                          disabled="disabled"
                        >
                          MEMPROSES...
                        </button>
                      {:else}
                        <button
                          type="submit"
                          class="w-auto px-6 py-2 mt-5 text-gray-100 bg-gray-700 rounded-lg text-1xl active:bg-gray-500 focus:outline-none"
                          on:click={handleSubmit}
                        >
                          SAVE
                        </button>
                      {/if}

                      <button
                        type="button"
                        on:click|preventDefault={() => {
                          require = {
                            username: "",
                            password: "",
                            name: "",
                            iface: "",
                            ipAddress: "",
                            isPublic: "",
                            descriptions: "",
                            setuju: "",
                          };
                        }}
                        class="w-auto px-5 py-2 mt-5 text-gray-100 bg-gray-600 rounded-lg text-1xl active:bg-gray-500 focus:outline-none"
                      >
                        RESET
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
</main>
